// import React, { useEffect, useState } from "react";
// import { getUserData, updateUserField } from "../firebase/firestoreService";

// const PlaceComponent = ({ email }) => {
//   const [place, setPlace] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       const userData = await getUserData(email);
//       if (userData?.place) {
//         setPlace(userData.place);
//       }
//     };
//     fetchData();
//   }, [email]);

//   const handleUpdate = async () => {
//     await updateUserField(email, "place", place);
//     alert("Place updated successfully!");
//   };

//   return (
//     <div>
//       <h3>Place</h3>
//       <input
//         type="text"
//         value={place}
//         onChange={(e) => setPlace(e.target.value)}
//       />
//       <button onClick={handleUpdate}>Update Place</button>
//     </div>
//   );
// };

// export default PlaceComponent;

import React, { useEffect, useState } from "react";
import { getUserData, updateUserField } from "../firebase/firestoreService"; // Assuming you have these functions
import "../../App.css"; // Assuming your global styles are in App.css
import LoadingPage from "./LoadingPage";
import { useNavigate } from "react-router-dom";

const style = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Poppins', sans-serif",
    backgroundColor: "#f0f5f1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(5px)", // Subtle background blur
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
    filter: "brightness(80%)", // Darken video for better contrast
  },
  formContainer: {
    background: "rgba(255, 255, 255, 0.3)", // Less transparency
    backdropFilter: "blur(10px)", // Slight blur
    padding: "15px 30px", // Reduced padding
    borderRadius: "15px", // Smaller border-radius for compactness
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Slightly smaller shadow
    textAlign: "center",
    maxWidth: "320px", // Smaller width
    width: "80%",
    border: "2px solid #f1f8e9",
  },
  h2: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: "1.6rem", // Slightly smaller font size
    marginBottom: "12px", // Reduced margin
    color: "#FFFFFF",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.4)",
  },
  input: {
    width: "100%",
    padding: "10px", // Reduced padding
    margin: "8px 0", // Reduced margin
    borderRadius: "8px", // Smaller border-radius
    border: "1px solid #FFFFFF",
    fontSize: "14px",
    backgroundColor: "#F1F8E9",
    boxSizing: "border-box",
    transition: "all 0.3s ease",
    outline: "none",
    color: "#333",
  },
  inputFocus: {
    borderColor: "#66bb6a",
    boxShadow: "0 0 6px rgba(102, 187, 106, 0.6)", // Subtle focus glow
  },
  button: {
    width: "100%",
    padding: "12px", // Reduced padding
    margin: "10px 0", // Slight margin reduction
    borderRadius: "8px", // Smaller border-radius
    border: "none",
    fontSize: "14px", // Slightly smaller font size
    cursor: "pointer",
    backgroundColor: "#66bb6a",
    color: "white",
    fontWeight: "bold",
    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.2s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  alert: {
    color: "red",
    fontSize: "12px",
    marginTop: "8px",
  },
};

const PlaceComponent = ({ email }) => {
  const [place, setPlace] = useState("");
  const [loading, setLoading] = useState(true); // Track loading state
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const userData = await getUserData(email);
      if (userData?.place) {
        setPlace(userData.place);
      }
      setLoading(false);
    };
    fetchData();
  }, [email]);

  const handleUpdate = async () => {
    await updateUserField(email, "place", place);
    alert("Place updated successfully!");
    if (window.history.length > 2) {
      navigate(-1); // Go back to the previous page
    } else {
      navigate('/dashboard'); // No history, go to dashboard
    }
  };

  if (loading) {
    return <LoadingPage />
  }

  return (
    <div style={style.container}>
      <video
        style={style.video}
        autoPlay
        loop
        muted
        playsInline
        onError={() => console.log("Error loading video. Check file path or format.")}
      >
        <source src={require("../videos/1.mp4")} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div style={style.formContainer}>
        <h2 style={style.h2}>Update Your Place</h2>
        <input
          style={style.input}
          type="text"
          value={place}
          onChange={(e) => setPlace(e.target.value)}
          placeholder="Enter your place"
          onFocus={(e) => e.target.style.borderColor = style.inputFocus.borderColor}
          onBlur={(e) => e.target.style.borderColor = "#66bb6a"}
        />
        <button style={style.button} onClick={handleUpdate}>Update Place</button>
        {place === "" && <p style={style.alert}>Please enter a place.</p>}
      </div>
    </div>
  );
};

export default PlaceComponent;
